import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
import { SEOService } from '../../../services/seo.service';

@Component({
  selector: 'app-annual-report',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './annual-report.component.html',
  styleUrl: './annual-report.component.scss'
})
export class AnnualReportComponent implements OnInit {

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private seoService: SEOService) { }
  nav(url: any) {
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/aboutcompany/kalpita-annual-reports') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }

  updateDescription(desc: string, keywords: string, title: string) {
    this.seoService.updateDescription(desc);
    this.seoService.updateMetaKeywords(keywords);
    this.seoService.updateTitle(title);
  }

  annualreport: any[] =
    [{
      url: '../../../../../../assets/annual-report/Form_MGT_7 KALPITA _2018-19.pdf',
      title: 'KT Annual report 2018 - 2019'
    },
    {
      url: '../../../../../../assets/annual-report/Form_MGT-7_KALPITA_2019-20.pdf',
      title: 'KT Annual report 2019 - 2020'
    },
    {
      url: '../../../../../../assets/annual-report/Form_MGT_7A KALPITA _2020-21.pdf',
      title: 'KT Annual report 2020 - 2021'
    },
    {
      url: '../../../../../../assets/annual-report/Form_MGT_7_Kalpita_2021-22.pdf',
      title: 'KT Annual report 2021 - 2022'
    },
    {
      url: '../../../../../../assets/annual-report/Form_MGT-7_KALPITA_2022-23.pdf',
      title: 'KT Annual report 2022 - 2023'
    },
    {
      url: '../../../../../../assets/annual-report/KTAnnual_report2023-24.pdf',
      title: 'KT Annual report 2023 - 2024'
    },
    {
      url: '../../../../../../assets/annual-report/KTAnnual_report2024-25.pdf',
      title: 'KT Annual report 2024 - 2025'
    }
    ]
}
